import type { QueryClient } from "@tanstack/react-query";

export function clearProtectedQueries(queryClient: QueryClient): void {
  queryClient.clear();
}
